import request from '@/router/axios';

const scope = 'server';

export const loginByUsername = (username, password, code, randomStr) => {
  const grant_type = 'password';
  return request({
    url: '/uaa/oauth/token',
    headers: {
      isToken: false,
      Authorization: 'Basic aW9sODppb2w4',
    },
    method: 'post',
    params: { username, password, randomStr, code, grant_type, scope },
  });
};

export const directLogin = (username, password) => {
  const grant_type = 'password';
  const isMD5 = 'isMD5';
  return request({
    url: '/uaa/oauth/token',
    headers: {
      isToken: false,
      Authorization: 'Basic aW9sODppb2w4',
      isDirect: 'Basic cG0=',
    },
    method: 'post',
    params: { username, password, grant_type, isMD5 },
  });
};

export const refreshToken = (refresh_token) => {
  const grant_type = 'refresh_token';
  return request({
    url: '/uaa/oauth/token',
    headers: {
      isToken: false,
      Authorization: 'Basic aW9sODppb2w4',
    },
    method: 'post',
    params: { refresh_token, grant_type, scope },
  });
};

export const getUserInfo = () => {
  return request({
    url: '/system/user/info',
    method: 'get',
  });
};

export const logout = () => {
  return request({
    url: '/uaa/token/logout',
    method: 'delete',
  });
};

export const queryByStaffId = (obj) => {
  return request({
    url: '/dotadmin/dotadmin/user/queryByStaffId',
    method: 'get',
    params: obj,
  });
};
